import { StoreBadge } from '@/components';
import { LanguageCode } from '@/interfaces';
import { StoreBadgesWrapper } from '../AppBadge/AppBadge.styles';

type AppStoreBadgeButtonProps = {
  appStoreUrl?: string;
  googlePlayUrl?: string;
};
const AppStoreBadgeButton = ({ appStoreUrl, googlePlayUrl }: AppStoreBadgeButtonProps) => {
  return (
    <StoreBadgesWrapper>
      <StoreBadge platform='apple' url={appStoreUrl} languageCode={LanguageCode.English} />
      <StoreBadge platform='google' url={googlePlayUrl} languageCode={LanguageCode.English} />
    </StoreBadgesWrapper>
  );
};

export { AppStoreBadgeButton };
